/** Client helpers for CardNexus (session cookie auth — no user API key). */

export async function cardnexusFetch<T>(
  path: string,
  init?: RequestInit,
): Promise<T> {
  const headers = new Headers(init?.headers);
  if (init?.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const res = await fetch(path, { ...init, headers, credentials: "same-origin" });
  const data = (await res.json().catch(() => ({}))) as T & { error?: string; code?: string };
  if (!res.ok) {
    const msg = (data as { error?: string }).error || `Erreur ${res.status}`;
    const err = new Error(msg) as Error & { status?: number; code?: string };
    err.status = res.status;
    err.code = (data as { code?: string }).code;
    throw err;
  }
  return data;
}

export function cardnexusConnectUrl(returnTo = "/inventaire"): string {
  const q = new URLSearchParams({ returnTo });
  return `/api/cardnexus/oauth/start?${q.toString()}`;
}
